import React from 'react';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import PropTypes from 'prop-types';
import translate from '@/lib/intl/translate';
import { TaskStatusEnum } from '../tasksConfig';

function TaskDisplaySelect({ className, filters, onFilterUpdate }) {
  const displaySelectItems = [
    { value: TaskStatusEnum.ALL, label: translate('TASKS_ALL') },
    {
      value: TaskStatusEnum.INCOMPLETE,
      label: translate('TASKS_INCOMPLETE'),
    },
    {
      value: TaskStatusEnum.COMPLETE,
      label: translate('TASKS_COMPLETE'),
    },
  ];

  return (
    <FormControl className={className}>
      <InputLabel className="whitespace-nowrap" id="task-display-select-label">
        {translate('DISPLAY')}
      </InputLabel>
      <Select
        labelId="task-display-select-label"
        id="task-display-select"
        value={filters?.status || TaskStatusEnum.INCOMPLETE}
        className="w-full"
        name="status"
        label={translate('DISPLAY')}
        onChange={onFilterUpdate}
        displayEmpty
      >
        {displaySelectItems.map((item) => (
          <MenuItem key={item.value} value={item.value}>
            {item.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
TaskDisplaySelect.propTypes = {
  className: PropTypes.string,
  filters: PropTypes.shape({
    userId: PropTypes.string,
    sortBy: PropTypes.string,
    sortOrder: PropTypes.string,
    status: PropTypes.string,
  }).isRequired,
  onFilterUpdate: PropTypes.func.isRequired,
};

TaskDisplaySelect.defaultProps = {
  className: '',
};
export default TaskDisplaySelect;
